export default (state, { customerProductId }) => state.customerProducts.data[customerProductId]?.name
